import { NitroDivider, NitroIcon } from "nitro-components";

import React, { Component, PropTypes } from "react";
import classNames from "classnames/bind";

import VehicleImage from "./VehicleImage";
import VehicleStats from "./VehicleStats";
import VehicleText from "./VehicleText";
import RegoPlate from "./RegoPlate";

const cx = classNames.bind();

import styled from "styled-components";

const VehicleDetailsContainer = styled.div`
  display: flex;
  flex-direction: ${props => (props.horizontal ? "row" : "column")};
  flex-wrap: wrap;
  align-items: center;
  justify-content:space-between;
`;

const InfoIcon = styled.div`
  line-height: 20px;

  padding: 0 15px;
  display: flex;
  flex-direction: column;
  justify-content: right;
  align-items: right;
  width:10%;
`;

const VehicleInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: ${props => props.showInfo ? 30 : 40}%;
  max-width: 130px;
  flex-shrink: 1;

  ${props => !props.horizontal && `
    width: 100%;
  `}
`;

const SideButtonContainer = styled.div`
  height: 30px;
  width: 30px;
  border-radius: 4px;
  align-items: center;
  display: flex;
  justify-content: center;
  background-color: ${props => props.theme.color.white};
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.15);
  text-align:center;
  vertical-align:center;
`;

const ExtendText = styled.div`
  width: 100%;
  ${/* flex-basis: 100%;
  align-self: stretch; */ ""}
`;

class VehicleDetails extends Component {
  onPanelClick = () => {
    if (this.props.disablePanelClick) {
      return;
    }

    const id = this.props.leaseId;

    if (this.props.route) {
      this.context.router.push({
        pathname: this.props.route,
        state: { id, dashboardType: "vehicle" }
      });
    }

    if (typeof this.props.onPanelClick === 'function') {
      this.props.onPanelClick(id);
    }
  };

  render() {
    const props = this.props;
    const vehicleTextProps = {
      makeModel: props.MakeModel,
      year: props.Year,
      makeName: props.MakeName,
      modelName: props.ModelName,
      bodyType: props.BodyType,
      driveType: props.DriveType,
      transmission: props.Transmission,
      fuelType: props.FuelType
    };

    const vehicleStatsProps = {
      ancapRating: props.AncapRating,
      co2Emissions: props.Co2Emissions,
      fuelConsumption: props.FuelConsumption
    };

    const {
      horizontal,
      showStats,
      showInfo,
      RegistrationNumber,
      headingVariant,
      bookmarked,
      horizontalImgWidthPercentage,
      disablePanelClick,
      route,
      onPanelClick,
    } = props;

    const canClick = !disablePanelClick && (route || onPanelClick);

    const vehicleDetailsClass = cx(["vehicle", { horizontal: horizontal }]);
    return (
      <VehicleDetailsContainer
        horizontal={horizontal}
        onClick={this.onPanelClick}
      >

        {bookmarked &&
          <SideButtonContainer>
            <NitroIcon
              name="filled-bookmark"
              size={14}
              variant="secondary"
              left={3}
            />
          </SideButtonContainer>}

        <VehicleImage imageKey={props.ImageKey} horizontal={horizontal} horizontalImgWidthPercentage={horizontalImgWidthPercentage} />

        <VehicleInfoContainer horizontal={horizontal} showInfo={showInfo}>
          <VehicleText {...vehicleTextProps} horizontal={horizontal} headingVariant={headingVariant} />

          {RegistrationNumber &&
            <RegoPlate active value={RegistrationNumber} />
          }
        </VehicleInfoContainer>

        {showStats &&
          <ExtendText>
            <NitroDivider />
            <VehicleStats {...vehicleStatsProps} />
          </ExtendText>}

        {(showInfo && canClick) &&
          <InfoIcon>
            <NitroIcon name="arrow-right" size={8} variant="base3" />
          </InfoIcon>
        }
      </VehicleDetailsContainer>
    );
  }
}

VehicleDetails.contextTypes = {
  router: PropTypes.object
};

VehicleDetails.propTypes = {
  disablePanelClick: PropTypes.bool,
  route: PropTypes.string,
  horizontal: PropTypes.bool,
  showStats: PropTypes.bool,
  showInfo: PropTypes.bool,
  MakeModel: PropTypes.string,
  MakeName: PropTypes.string,
  ModelName: PropTypes.string,
  Year: PropTypes.string,
  BodyType: PropTypes.string,
  DriveType: PropTypes.string,
  Transmission: PropTypes.string,
  FuelType: PropTypes.string,
  ImageKey: PropTypes.string,
  AncapRating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  Co2Emissions: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  FuelConsumption: PropTypes.string,
  RegistrationNumber: PropTypes.string,
  leaseId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bookmarked: PropTypes.bool,
  onPanelClick: PropTypes.func,
  headingVariant: PropTypes.string,
  horizontalImgWidthPercentage: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default VehicleDetails;



// WEBPACK FOOTER //
// ./src/components/vehicle/VehicleDetails.js